<template>
  <el-form :model="formValue" :rules="rules" @submit.native.prevent ref="formValue">
    <p class="txt">感谢你对我们的关注，请填写详细需求以便我们更快的与你联系。</p>
    <el-form-item prop="desiredCooperationField">
      <el-select v-model="formValue.desiredCooperationField" placeholder="您有意向的合作方向是？">
        <el-option label="智能网联" value="智能网联"></el-option>
        <el-option label="自动驾驶" value="自动驾驶"></el-option>
        <el-option label="数字营销" value="数字营销"></el-option>
        <el-option label="用车服务" value="用车服务"></el-option>
        <el-option label="其他" value="其他"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item prop="currentProjectStage">
      <el-select v-model="formValue.currentProjectStage" placeholder="您当前项目的阶段是？">
        <el-option label="尚无项目" value="尚无项目"></el-option>
        <el-option label="规划中" value="规划中"></el-option>
        <el-option label="洽谈中" value="洽谈中"></el-option>
        <el-option label="执行中" value="执行中"></el-option>
        <el-option label="已交付" value="已交付"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item prop="question">
      <el-input v-model="formValue.question" autocomplete="off" placeholder="请详细描述您的合作诉求"></el-input>
    </el-form-item>
    <el-form-item prop="companyName">
      <el-input v-model="formValue.companyName" autocomplete="off" placeholder="公司名称"></el-input>
    </el-form-item>
    <el-form-item prop="abbreviation">
      <el-input v-model="formValue.abbreviation" autocomplete="off" placeholder="公司简称"></el-input>
    </el-form-item>
    <el-form-item prop="companyType">
      <el-input v-model="formValue.companyType" autocomplete="off" placeholder="公司类型"></el-input>
    </el-form-item>
    <el-form-item prop="companyCreditCode">
      <el-input v-model="formValue.companyCreditCode" autocomplete="off" placeholder="统一社会信用代码"></el-input>
    </el-form-item>
    <el-form-item prop="companyBusinessBrief">
      <el-input v-model="formValue.companyBusinessBrief" autocomplete="off" placeholder="公司业务简介"></el-input>
    </el-form-item>
    <el-form-item prop="companyHomeUrl">
      <el-input v-model="formValue.companyHomeUrl" autocomplete="off" placeholder="公司网址"></el-input>
    </el-form-item>
    <el-form-item prop="contactName">
      <el-input v-model="formValue.contactName" autocomplete="off" placeholder="联系人姓名"></el-input>
    </el-form-item>
    <el-form-item prop="contactTel">
      <el-input v-model="formValue.contactTel" autocomplete="off" placeholder="联系人电话"></el-input>
    </el-form-item>
    <el-form-item prop="contactEmail">
      <el-input v-model="formValue.contactEmail" autocomplete="off" placeholder="联系人邮箱"></el-input>
    </el-form-item>
    <div class="buttons">
      <el-button type="primary" @click="onSubmit" :loading='isLoading'>提交</el-button>
    </div>
  </el-form>
</template>

<script>
import apiService from '../api/consulting/consulting';
export default {
  name: 'consulting',
  // props: {
  //   position:{
  //     default: 'right',
  //     type: String
  //   }
  // },
  data() {
    return {
      isLoading:false,
      formValue:{},
      rules:{
      'desiredCooperationField':[{required: true, message: '请选择合作方向', trigger:'change'}],
      //'currentProjectStage': [{required: true, message:"请选择当前项目的阶段",trigger:'change'}],
      'question':[{required: true, message:"请输入您的合作诉求",trigger: 'blur'}],
      'companyName':[{required:true, message: '请输入公司名称',trigger: 'blur'}],
      'abbreviation':[{required:true, message: '请输入公司简称',trigger: 'blur'}],
      'companyType':[{required:true, message: '请输入公司类型',trigger: 'blur'}],
      'companyCreditCode':[{required:true, message: '请输入统一社会信用代码',trigger: 'blur'}],
      'companyBusinessBrief':[{required:true, message: '请输入公司业务简介',trigger: 'blur'}],
      'companyHomeUrl':[{required:true, message: '请输入公司网址',trigger: 'blur'}],
      'contactName':[{required:true, message: '请输入联系人姓名',trigger: 'blur'}],
      'contactTel':[{required:true, message: '请输入联系人电话',trigger: 'blur'}],
      'contactEmail':[{required:true, message: '请输入联系人邮箱',trigger: 'blur'}],
      }
    }
  },
  methods:{
    onSubmit(){
      this.$refs.formValue.validate((valid) => {
        if (valid) {
          this.isLoading=true;
          const params = {
            issue:this.formValue,
          }
          apiService.submitIssue(params).then(
            result => {
              this.isLoading=false
              if (result.code === 0) {
                this.$message.success("提交成功");
                this.$emit("close");
              }
            },
          ).catch((error) => {
            this.isLoading=false
            this.$message.error(`${error}`);
          })
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form{
  text-align: center;
}
/deep/ input::placeholder{
  color: #b3b3b3;
}
.txt{
  margin-bottom: 30px;
}
.el-input, .el-select{
  width: 90%;
}
/deep/ .el-form-item__error{
  left:5%
}
.buttons{
  margin-top: 40px;
}
.el-button{
  width: 100px;
  padding: 0 27px;
  height: 30px;
}
</style>
